// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"80de0338","703":"2fe303bc","787":"2c673886"}[chunkId] + ".chunk.js";
};